module.exports = __webpack_public_path__ + "assets/img/video_post.a787cd9d.jpg";